import { styled } from 'linaria/react';

export const RoomParamsContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: var(--space-250);
  margin-bottom: var(--space-400);
  border: solid 1px var(--control-secondary);
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;

  @media (--to-tablet) {
    padding: var(--space-200);
    margin-bottom: var(--space-400);
  }

  @media (--only-mobile) {
    margin-bottom: var(--space-400);
  }
`;

export const ParamsListContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-300);
  width: 100%;

  @media (--only-mobile) {
    flex-wrap: nowrap;
  }
`;
